import { request } from '@/api/request';
import { GetterTree, MutationTree, ActionTree } from 'vuex';
import { RootState, cardRemittancesMerchantState } from '@/util/interface';
import { STATUS_ERROR } from '@/constant';

const state: cardRemittancesMerchantState = {
  remittancesToCard: {},
  remittancesToCardErrors:{},
  remittancesToCardStatus: {},
  remittancesToCardConfirm: {}

};
const getters: GetterTree<cardRemittancesMerchantState, RootState> = {
  remittancesToCard: (state) => state.remittancesToCard,
  remittancesToCardErrors: (state) => state.remittancesToCardErrors,
  remittancesToCardStatus: (state) => state.remittancesToCardStatus,
  remittancesToCardConfirm: (state) => state.remittancesToCardConfirm,
};
const actions: ActionTree<cardRemittancesMerchantState, RootState> = {
  prevalidationRemittancesToCard ({ commit }, data) {
    return request({ url: 'transfer/sim2card/info',
      method: 'post' ,
      data })
      .then((res) => {
        res.data.status === STATUS_ERROR
          ? commit('setRemittancesToCardErrors', res.data)
          : commit('setRemittancesToCardErrors', {});
        
        commit('setRemittancesToCard', 
          { 
            ...res.data,
            ...data 
          });
        return res.data;
        
      }).catch((err) => {
        if (err?.response?.data) {
          commit('setRemittancesToCardErrors', err.response.data.errors);
          return err.response;
        }
      });
  },
  initializationCardRemittances    ({ commit }, data) {
    return request({ url: 'transfer/sim2card/init',
      method: 'post',
      data })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        if (err?.response?.data) {
          commit('setRemittancesToCardErrors', err.response.data.errors);
          return err.response;
        }
      });
  },

  confirmRemittancesToCard ({ commit }, data) {
    commit('setLoading', true, { root: true });
    return request(
      { url: 'transfer/sim2card/confirm',
        method: 'post' ,
        data })
      .then((res) => {
        if (res.data.status === STATUS_ERROR) {
          commit('setRemittancesToCardErrors', res.data);
        }
        commit('setRemittancesToCardConfirm', res.data);

        return res.data;
      }).catch((err) => {
        if (err?.response?.data) {
          commit('setRemittancesToCardErrors', err.response.data);
          return err.response;
        }
      }).finally(() => {
        commit('setLoading', false, { root: true });
      });
  },

  async getStatusOfRemittancesToCard ({ commit }, data) {
    return await request({ url: 'status',
      method: 'post' ,
      data })
      .then((res) => {
        commit('setRemittancesToCardStatus', res.data);
      });
  },
  
};
const mutations: MutationTree<cardRemittancesMerchantState> = {
  setRemittancesToCard (state, data) {
    state.remittancesToCard = { ...data };
  },
  setRemittancesToCardErrors (state, data) {
    state.remittancesToCardErrors = { ...data };
  },
  setRemittancesToCardStatus(state, payload) {
    state.remittancesToCardStatus = payload;
  },
  setRemittancesToCardConfirm(state, payload) {
    state.remittancesToCardConfirm = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
  